export const ContactSectionVariants = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};
